import React, { useState, useEffect, useReducer, useRef } from 'react';
// import { api, APIS } from '@/api';
import { Form, Button, Input, Modal, Space, message } from 'antd';
import CalculateFormulaList from './calculateFormulaList'; //引用表达式列表
import { modalExpressRunFn } from '../../expressionManage/components/expressRun';
import styles from './index.module.less';
const TextArea = Input.TextArea;
import { isNil } from 'lodash';

interface CollectionCreateFormProps {
  onFromSubmit: (type: any, values: any) => void;
  onCancel: () => void;
  props: any;
}

const CalcForm: React.FC<CollectionCreateFormProps> = ({ onFromSubmit, onCancel, props }) => {
  const { visible, type, index, calculateFormulaData, currentDatails } = props;
  const [form] = Form.useForm();
  const [openData, setOpenData] = useState(false);
  const textAreaRef = useRef(null);
  useEffect(() => {
    onReset();
    if (visible) {
      console.log(currentDatails);

      // 有id 则代表是引用
      if (currentDatails?.calculateFormulaId) {
        form.setFieldsValue({
          isQuote: true,
          calculateFormula: currentDatails?.calculateFormula,
          calculateFormulaName: currentDatails?.calculateFormulaName,
        });
      } else {
        form.setFieldsValue({
          isQuote: false,
          calculateFormula: currentDatails?.calculateFormula,
        });
      }
    }
  }, [visible]);

  // 重置
  const onReset = () => {
    form.resetFields();
  };
  // 提交
  const onFinish = () => {
    const values = form.validateFields(); //触发表单验证
    values.then((res) => {
      console.log(res);
      onFromSubmit && onFromSubmit({ ...res, index });
    });
  };

  const _onClose = () => {
    onCancel && onCancel();
  };

  const formItemLayout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 16 },
  };
  const formItemLayout3 = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };

  const editBar: any = {
    border: '1px solid #e6e6e6',
    borderRadius: '10px',
    minHeight: '210px',
    width: '100%',
    padding: '4px 4px',
  };
  const checkBox: any = {
    color: '#1890ff',
    border: '1px solid #1890ff',
    padding: '2px 6px',
    marginLeft: '4px',
    borderRadius: '5px',
    marginBottom: '6px',
    cursor: 'pointer',
    display: 'inline-block',
  };
  const checkBoxDisabled: any = {
    color: '#f5f5f5',
    border: '1px solid #f5f5f5',
    padding: '2px 6px',
    marginLeft: '4px',
    borderRadius: '5px',
    marginBottom: '6px',
    cursor: 'not-allowed',
    display: 'inline-block',
    background: '#d9d9d9',
  };
  const checkBox2: any = {
    color: '#faad14',
    border: '1px solid #faad14',
    padding: '2px 6px',
    marginLeft: '4px',
    borderRadius: '5px',
    marginBottom: '6px',
    cursor: 'pointer',
    display: 'inline-block',
  };
  // 结果演算
  const onExpress = () => {
    if (form.getFieldValue('calculateFormula')) {
      modalExpressRunFn(form.getFieldValue('calculateFormula'));
    } else {
      message.error('请输入表达式');
      return false;
    }
  };
  const getCursorPosition = (ctrl: any) => {
    const CaretPos = {
      start: 0,
      end: 0,
    };
    if (ctrl?.resizableTextArea?.textArea.selectionStart) {
      CaretPos.start = ctrl?.resizableTextArea?.textArea.selectionStart;
    }
    if (ctrl?.resizableTextArea?.textArea.selectionEnd) {
      CaretPos.end = ctrl?.resizableTextArea?.textArea.selectionEnd;
    }
    return CaretPos;
  };

  const setCursorPosition = (ctrl: any, start: any, end: any) => {
    ctrl.focus();
    // ctrl.setSelectionRange(start, end);  // 废弃
    if (ctrl?.resizableTextArea?.textArea.selectionStart) {
      ctrl.resizableTextArea.textArea.selectionStart = start;
    }
    if (ctrl?.resizableTextArea?.textArea.selectionEnd) {
      ctrl.resizableTextArea.textArea.selectionEnd = end;
    }
  };

  const cursorRef = useRef({
    start: 0,
    end: 0,
  });
  const handleRecordCursorPosition = () => {
    const position = getCursorPosition(textAreaRef.current); //获取光标位置
    cursorRef.current = position;
  };

  const handleBlur = () => {
    handleRecordCursorPosition();
  };

  const handleChangeRuleText = (e: any) => {
    // setRuleText(e.target.value);
    handleRecordCursorPosition();
  };

  const timeOutRef: any = useRef();

  const chooseField = (v: any) => {
    const { isQuote } = form.getFieldsValue();
    if (isQuote) return;

    let repeatVal = v.replaceAll('.', '．'); //英文字符替换成中文字符
    repeatVal = repeatVal.replaceAll('*', '＊'); //英文字符替换成中文字符
    repeatVal = repeatVal.replaceAll('[', '［'); //英文字符替换成中文字符
    repeatVal = repeatVal.replaceAll(']', '］'); //英文字符替换成中文字符
    const { calculateFormula } = form.getFieldsValue();

    // form.setFieldsValue({
    //   calculateFormula: isNil(calculateFormula) ? `${repeatVal}` : `${calculateFormula}${repeatVal}`,
    // });

    if (calculateFormula?.length) {
      const insertStart = cursorRef.current.start; //插入的位置
      const insertEnd = cursorRef.current.end + calculateFormula.length; //插入结束的位置
      // 截取插入位置前面的数据+选择的数据+截取插入位置前面的数据
      const newText = calculateFormula.slice(0, insertStart) + repeatVal + calculateFormula.slice(insertStart);
      timeOutRef.current = setTimeout(() => {
        setCursorPosition(textAreaRef.current, insertStart, insertEnd);
      }, 200);
      form.setFieldsValue({
        calculateFormula: isNil(newText) ? `${repeatVal}` : `${newText}`,
      });
    } else {
      form.setFieldsValue({
        calculateFormula: `${repeatVal}`,
      });
    }
  };

  const onOkData = (rows: any) => {
    const obj = rows[0];
    console.log(obj);
    setOpenData(false);

    form.setFieldsValue({
      isQuote: true,
      calculateFormulaId: obj?.id,
      calculateFormulaName: obj?.name,
      calculateFormula: obj?.formula,
    });
  };
  const onCancelData = () => {
    setOpenData(false);
  };

  const quoteFormula = () => {
    const { calculateFormula } = form.getFieldsValue();
    if (!isNil(calculateFormula)) {
      message.warning('请先清空表达式!');
      return;
    }
    setOpenData(true);
  };

  const modalTitleRender = () => {
    const { isQuote, calculateFormula } = form.getFieldsValue();
    let isDisabled = false;
    if (type == 'edit') {
      isDisabled = true;
    } else {
      if (isNil(isQuote) && !isNil(calculateFormula)) {
        isDisabled = true;
      } else {
        isDisabled = false;
      }
    }

    return (
      <div>
        <Space>
          <span>业财字段值转换表达式</span>
          {/* <Button type={'primary'} size="small" disabled={type !== 'add'} onClick={() => setOpenData(true)}> */}

          <Button type={'primary'} size="small" disabled={isDisabled} onClick={quoteFormula}>
            引用
          </Button>
          <Button type={'primary'} size="small" onClick={onExpress}>
            结果演算
          </Button>
        </Space>
      </div>
    );
  };
  return (
    <div>
      <Modal
        width={1140}
        visible={props?.visible}
        title={modalTitleRender()}
        onCancel={_onClose}
        footer={[
          <Button type="primary" ghost onClick={() => form.resetFields()}>
            清空
          </Button>,
          <Button type="primary" onClick={onFinish}>
            确定
          </Button>,
        ]}
      >
        <Form form={form} onFinish={onFinish} {...formItemLayout}>
          <div>
            <Form.Item
              label="是否是引用表达式"
              name="isQuote"
              {...formItemLayout3}
              rules={[{ required: false }]}
              noStyle
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="主规则ID"
              name="ruleConfigId"
              {...formItemLayout3}
              rules={[{ required: false }]}
              noStyle
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="子规则ID"
              name="ruleConfigDtlId"
              {...formItemLayout3}
              rules={[{ required: false }]}
              noStyle
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="引用计算公式id"
              name="calculateFormulaId"
              {...formItemLayout3}
              rules={[{ required: false }]}
              noStyle
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="引用计算公式name"
              name="calculateFormulaName"
              {...formItemLayout3}
              rules={[{ required: false }]}
              noStyle
              hidden
            >
              <Input />
            </Form.Item>

            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <div style={editBar}>
                    <p>可选字段</p>
                    {(calculateFormulaData?.billFormulaList || []).map((item: any, i: number) => {
                      return (
                        <span
                          style={getFieldValue('isQuote') ? checkBoxDisabled : checkBox}
                          onClick={() => chooseField(item)}
                          className={styles.item}
                          key={`item${i}`}
                        >
                          {item}
                        </span>
                      );
                    })}
                    {/* {(calculateFormulaData?.busMattersOfBillList || []).map((item: any) => {
                      return (
                        <span
                          style={getFieldValue('isQuote') ? checkBoxDisabled : checkBox2}
                          onClick={() => chooseField(item?.billId)}
                          className={styles.item}
                          key={item?.billId}
                        >
                          {`${item?.billName}#${item?.billId}`}
                        </span>
                      );
                    })} */}
                    <div>
                      <Form.Item
                        name="calculateFormula"
                        {...formItemLayout3}
                        rules={[{ required: false, message: '请选输入表达式' }]}
                      >
                        <TextArea
                          ref={textAreaRef}
                          onChange={handleChangeRuleText}
                          onBlur={handleBlur}
                          autoSize={{ minRows: 3, maxRows: 4 }}
                          style={{ width: '100%' }}
                          disabled={getFieldValue('isQuote')}
                          // onChange={changeFormula}
                        />
                      </Form.Item>
                    </div>
                  </div>
                );
              }}
            </Form.Item>
          </div>
        </Form>
      </Modal>

      <CalculateFormulaList
        open={openData}
        config={form}
        type={'radio'}
        showMode="drawer"
        title={'表达式列表'}
        width={660}
        onOk={onOkData}
        onCancel={onCancelData}
      />
    </div>
  );
};

export default CalcForm;
